var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState, useCallback } from 'react';
import * as ServiceOffre from '../../services/offre';
import { Stack } from '@mui/material';
import { IconButton } from '../../utils/IconButton';
import { CloseIcon, CollaborateurIcon, DownIcon, UpIcon, EditIcon, } from '../../utils/Icons';
import { formatNumber } from '../../services/utils/utils';
import { Loader } from '../../utils/Loader';
import { Typography } from '../../utils/Typography';
import { Table, renderInfo } from '../../utils/Table';
import { EditionOffre } from './EditionOffre';
import { ConfirmDialog } from '../../utils/ConfirmDialog';
import { getIsMobile } from '../../services/utilisateur';
export var Offre = function (props) {
    var AffaireId = props.AffaireId, canEdit = props.canEdit, onChange = props.onChange;
    var _a = useState(true), loading = _a[0], setLoading = _a[1];
    var _b = useState([]), offres = _b[0], setOffres = _b[1];
    var isMobile = getIsMobile();
    var getData = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var datas;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, ServiceOffre.getOffreListe(AffaireId)];
                case 1:
                    datas = _a.sent();
                    setOffres(datas);
                    onChange(datas);
                    setLoading(false);
                    return [2 /*return*/];
            }
        });
    }); }, [AffaireId]);
    useEffect(function () {
        getData();
    }, []);
    if (loading) {
        return _jsx(Loader, {});
    }
    var changeOrdre = function (offre, up) {
        if (up === void 0) { up = false; }
        return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, ServiceOffre.postOffreOrdre(offre.IdOffre, up)];
                    case 1:
                        _a.sent();
                        getData();
                        return [2 /*return*/];
                }
            });
        });
    };
    var renderUpDown = function (value) {
        return (_jsxs(Stack, __assign({ spacing: 1, direction: "row" }, { children: [_jsx(IconButton, __assign({ size: "small", tooltip: "Monter d'un rang", disabled: !canEdit || value.Ordre <= 1, onClick: function () {
                        changeOrdre(value, true);
                    } }, { children: _jsx(UpIcon, { fontSize: "small" }) })), _jsx(IconButton, __assign({ size: "small", tooltip: "Descendre d'un rang", disabled: !canEdit || value.Ordre >= offres.length, onClick: function () {
                        changeOrdre(value, false);
                    } }, { children: _jsx(DownIcon, { fontSize: "small" }) }))] })));
    };
    return (_jsx(Table, { color: "affaire", canEdit: canEdit, datas: offres, renderModalEdition: function (handleClose, offreSelected) { return (_jsx(EditionOffre, { AffaireId: AffaireId, offre: offreSelected, handleClose: function () {
                handleClose();
                getData();
            } })); }, isResponsive: true, headers: __spreadArray(__spreadArray(__spreadArray(__spreadArray([], (isMobile
            ? [
                {
                    label: '',
                    component: function (value) {
                        return _jsx(_Fragment, { children: value.Designation });
                    },
                },
            ]
            : []), true), (canEdit && !isMobile
            ? [
                {
                    minWidth: true,
                    component: function (value) {
                        return renderUpDown(value);
                    },
                },
            ]
            : []), true), [
            {
                label: 'Gamme',
                component: function (value) {
                    return (_jsxs(_Fragment, { children: [value.catalogue.Catalogue_Famille.Libelle, value.TypeCatalogueLibelle &&
                                renderInfo(value.TypeCatalogueLibelle)] }));
                },
            },
            {
                label: 'Produit / Service',
                component: function (value) {
                    return (_jsxs(_Fragment, { children: [value.Designation, value.catalogue.Libelle !== value.Designation &&
                                renderInfo(value.catalogue.Libelle)] }));
                },
            },
            {
                align: 'right',
                label: 'Quantité',
                component: function (value) {
                    return value.WithQuantite
                        ? "".concat(formatNumber(value.Quantite, value.Unite))
                        : null;
                },
            },
            {
                label: 'Tarif',
                align: 'right',
                component: function (value) {
                    return (_jsxs(_Fragment, { children: [_jsx(Typography, __assign({ variant: "body2", sx: { minWidth: 80 } }, { children: formatNumber(value.TotalTarif, '€') })), value.WithQuantite &&
                                value.Tarif &&
                                value.Tarif !== value.TotalTarif ? (renderInfo("".concat(formatNumber(value.Tarif, '€'), "/unit\u00E9"), {
                                right: true,
                            })) : (_jsx(_Fragment, {}))] }));
                },
            },
            {
                label: 'Coût',
                align: 'right',
                component: function (value) {
                    var TotalCout = value.TotalTarif - value.TotalMarge;
                    return (_jsxs(_Fragment, { children: [_jsx(Typography, __assign({ variant: "body2", sx: { minWidth: 80 } }, { children: formatNumber(TotalCout, '€') })), value.WithQuantite &&
                                value.Cout &&
                                value.Cout !== TotalCout ? (renderInfo("".concat(formatNumber(value.Cout, '€'), "/unit\u00E9"), {
                                right: true,
                            })) : (_jsx(_Fragment, {}))] }));
                },
            },
            {
                label: 'Collaborateurs',
                component: function (value) {
                    var offreCollaborateurs = value.offre__collaborateurs
                        ? value.offre__collaborateurs
                        : [];
                    return (_jsx(Typography, __assign({ variant: "body2", className: "mr-xsmall bold", sx: { color: 'collaborateur.main' }, startIcon: _jsx(CollaborateurIcon, { sx: { color: 'collaborateur.main' } }), noWrap: true }, { children: offreCollaborateurs.length === 1
                            ? offreCollaborateurs[0].collaborateur.getLibelle
                            : "".concat(offreCollaborateurs.length, " collaborateurs") })));
                },
            }
        ], false), (canEdit
            ? [
                {
                    label: '',
                    minWidth: true,
                    align: 'right',
                    component: function (value, _a) {
                        var handleUpdate = _a.handleUpdate;
                        return (_jsxs(Stack, __assign({ direction: "row", justifyContent: "space-between", spacing: 2 }, { children: [_jsxs(Stack, __assign({ direction: "row" }, { children: [_jsx(IconButton, __assign({ color: "primary", tooltip: "Modifier", onClick: function () { return handleUpdate(value); } }, { children: _jsx(EditIcon, {}) })), _jsx(IconButton, __assign({ size: "small", color: "error", tooltip: "Supprimer l'offre", onClick: function () { return __awaiter(void 0, void 0, void 0, function () {
                                                var confirmation;
                                                return __generator(this, function (_a) {
                                                    switch (_a.label) {
                                                        case 0: return [4 /*yield*/, ConfirmDialog({
                                                                title: 'Suppression',
                                                                content: 'Êtes-vous sûr de vouloir supprimer ce produit / service ?',
                                                                color: 'error',
                                                            })];
                                                        case 1:
                                                            confirmation = _a.sent();
                                                            if (!confirmation.isOk) return [3 /*break*/, 3];
                                                            return [4 /*yield*/, ServiceOffre.deleteOffre(value.IdOffre)];
                                                        case 2:
                                                            _a.sent();
                                                            getData();
                                                            _a.label = 3;
                                                        case 3: return [2 /*return*/];
                                                    }
                                                });
                                            }); } }, { children: _jsx(CloseIcon, { fontSize: "small" }) }))] })), isMobile && renderUpDown(value)] })));
                    },
                },
            ]
            : []), true) }));
};
//# sourceMappingURL=Offre.js.map